import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { fetchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import CircularProgress from '@mui/material/CircularProgress';
import '../common.css';

function CompanyIndex() {
  const { isAuthenticated, companyId, isSuperAdmin, superCompanyId, logout, token } = useAuth();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  let companyid = companyId;
  if (isSuperAdmin === true && companyId === superCompanyId) {
    companyid = 0;
  }

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }
    fetchTableData();
  }, [isAuthenticated, companyId, token, logout]);

  const fetchTableData = async () => {
    setLoading(true);
    fetchData('CompanyApi', '/' + companyid, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Company Details:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  return (
    <div className="page-container">
      {loading && (
        <div className="loading-overlay">
          <CircularProgress size={40} className="loading-spinner" />
          <span className="loading-text">Loading...</span>
        </div>
      )}

      <div className="page-header">
        <h1 className="page-title">Company</h1>
        <div className="header-actions">
          <div className="search-box">
            <SearchIcon />
            <input
              type="text"
              className="search-input"
              placeholder="Search company..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
      </div>

      <div className="table-container">
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Company Code</th>
                <th>Contact</th>
                <th>Cash in Hand</th>
                <th>GST Number</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((item) => (
                  <tr key={item.Id}>
                    <td className="cell-primary">{item.Name}</td>
                    <td>{item.CompanyCode}</td>
                    <td>{item.ContactNumber1}</td>
                    <td className="cell-amount">{item.Cashinhand}</td>
                    <td>{item.GSTNumber}</td>
                    <td>
                      <div className="action-buttons">
                        <Link to={'/companyEdit/' + item.ID}>
                          <button className="action-btn edit" title="Edit">
                            <EditIcon fontSize="small" />
                          </button>
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">
                    <div className="empty-state">
                      <p>No companies found</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default CompanyIndex;